// Katalog göstergesi "Standart gereksinimleri" alanı [{standard, code}] — MetricModal'dan ayrıldı
// (dosya ≤600 satır). Disclosure hazırlık ekranı bu eşlemeleri okur.

import { type KpiMetricRequirement } from "@mahir/shared";
import { btnSmall, fieldStyle, inputStyle, labelStyle } from "./kpi-form-styles";

export function MetricRequirementsField({
  value,
  disabled,
  onChange,
}: {
  value: KpiMetricRequirement[];
  disabled: boolean;
  onChange: (next: KpiMetricRequirement[]) => void;
}): JSX.Element {
  return (
    <div style={fieldStyle}>
      <span style={labelStyle}>Standart gereksinimleri</span>
      {value.map((r, i) => (
        <div key={i} className="flex items-center gap-2">
          <input
            aria-label={`Gereksinim ${i + 1} standart`}
            style={{ ...inputStyle, flex: 1, minHeight: 34, padding: "4px 8px" }}
            placeholder="GRI"
            value={r.standard}
            disabled={disabled}
            onChange={(e) =>
              onChange(value.map((x, j) => (j === i ? { ...x, standard: e.target.value } : x)))
            }
          />
          <input
            aria-label={`Gereksinim ${i + 1} kod`}
            style={{ ...inputStyle, flex: 1, minHeight: 34, padding: "4px 8px" }}
            placeholder="302-1"
            value={r.code}
            disabled={disabled}
            onChange={(e) =>
              onChange(value.map((x, j) => (j === i ? { ...x, code: e.target.value } : x)))
            }
          />
          <button
            type="button"
            style={{ ...btnSmall, minHeight: 34 }}
            disabled={disabled}
            aria-label={`Gereksinim ${i + 1} kaldır`}
            onClick={() => onChange(value.filter((_, j) => j !== i))}
          >
            ×
          </button>
        </div>
      ))}
      <div>
        <button
          type="button"
          style={btnSmall}
          disabled={disabled}
          onClick={() => onChange([...value, { standard: "", code: "" }])}
        >
          ＋ Gereksinim
        </button>
      </div>
    </div>
  );
}
